import axios from 'axios'
import map from 'lodash/map'

const getTags = (term, host = '') => {

  if (term.length < 2) return Promise.resolve([])
  return axios.get(host + `/service/topic/topics?phrase=${term}&limit=6`)
    .then((response) => {

      return map(response.data.topics, (el) => {

        return {
          label: el.title,
          value: el.title
        }

      })

    })

}

export default getTags
